export const CREATE_SUBSCRIPTION_CACHE_KEY = 'create-subscription';
export const ROSS_CREATE_SUBSCRIPTION_CACHE_KEY = 'create-subscription-ross';
export const HMH_CREATE_SUBSCRIPTION_PAGE_ID = 'G5EC58CU5PG4N2SR';
export const MAX_RECURRING_SUBSCRIPTION_LIMIT = 20;
export const HOURLY_TIME_UNIT_ID = 'hour';

export const enum STATIC_HMH_GUID {
  GLOBAL_TIMEZONE = 'GG3CKB63UG7YHYJD-G5UTPFECZ4KQLFS5',
  GLOBAL_COV_LEARN_MORE = 'GG3CKB63UG7YHYJD-G6DSPWH6W6Y9BUNM',
  GLOBAL_MULTI_COUNTRY_FIT = 'GG3CKB63UG7YHYJD-GWRMU86EQE5UV7MJ',
  BENCHMARKS_LEARN_MORE = 'GG3CKB63UG7YHYJD-GG6KEXUF3D9G59KY',
  MTA_LEARN_MORE = 'GG3CKB63UG7YHYJD-GTSQKTRGZ4VSJ35J'
}
